import styled from "@emotion/styled";
import { LinearProgress } from "@mui/material";
import React from "react";

const StyledLinearProgress = styled(LinearProgress)(
  ({ colors }) => ({
    height: "0.25rem",
    "& .MuiLinearProgress-bar": {
      backgroundColor: colors.primary.main, // Progress color   
    },

    "&.MuiLinearProgress-root": {
      borderRadius: "1rem",
      backgroundColor: colors.border.muted, // Track color // Progress color
      },
  })
);

export default StyledLinearProgress;
